import './assets/styles/main.scss';

import { createApp } from 'vue';
import router from '@/routes/router';
import App from '@/App.vue';
import * as Sentry from '@sentry/vue';

const app = createApp(App);

app.use(router);
router.isReady().then(() => {
  app.mount('#app');
});

console.log(window.MY_BUILD_VERSION, JSON.stringify(window.MY_BUILD_VERSION));

if (import.meta.env.MODE === 'production') {
  try {
    Sentry.init({
      app,
      dsn: 'https://9e34626d0faa712a17b599cfd23f3a95@sentry.zarinpal.com/42',
      release: window.MY_BUILD_VERSION,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
          blockAllMedia: false,
        }),
      ],
      tracePropagationTargets: [import.meta.env.VITE_APP_BASE_DOMAIN as string],
      tracesSampleRate: 1.0,
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  } catch (error) {
    console.log('****** installSentry / error', error);
  }
}
